export default "__VITE_ASSET__MDs49am7__"